import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { ListForecastMonth } from 'src/app/core/models/forecast.models';
import {
	ForecastCampaignPeriods,
	ForecastCampaignService,
	ForecastCampaignTypeService,
} from '../../services/forecast-campaigns-list.service';
import { ListForecastService } from '../../services/forecast-list.service';
import { ListForecastServiceMonthSearch } from '../../services/forecastmonthsearch-list.service';
import { NgbdOrdersSortableHeader } from '../../listjs-sortable-forecast-list.directive';

@Component({
	selector: 'app-real-month',
	templateUrl: './real-month.component.html',
	styleUrls: ['./real-month.component.scss'],
	providers: [
		ListForecastService,
		ForecastCampaignService,
		ForecastCampaignTypeService,
	],
})
export class RealMonthComponent implements OnInit {
	// Table data Month
	ListJsListMonth$!: Observable<ListForecastMonth[]>;
	total$: Observable<number>;
	@ViewChildren(NgbdOrdersSortableHeader)
	headers!: QueryList<NgbdOrdersSortableHeader>;

	//data Campaigns
	campaignList: any = [];
	campaignTypeList: any = [];
	campaignPeriods: any = [];
	submitted = false;
	isHidden: boolean = false;
	private selectedCampaignMonth: number;
	selectedTypeCampaignMonth = '';
	keyword = 'name';
	isSearch: boolean = false;

	constructor(
		public service: ListForecastService,
		public servicemonthsearch: ListForecastServiceMonthSearch,
		public forecastCampaignService: ForecastCampaignService,
		public forecastCampaignTypeService: ForecastCampaignTypeService,
		public forecastCampaignPeriods: ForecastCampaignPeriods,
	) {
		this.ListJsListMonth$ = service.list_result$;
		this.total$ = service.total$;
	}

	ngOnInit(): void {
		this.forecastCampaignService
			.getCampaigns()
			.subscribe((response: any) => (this.campaignList = response.body));

		this.forecastCampaignTypeService
			.getCampaignTypes()
			.subscribe(
				(response: any) => (this.campaignTypeList = response.body),
			);

		this.forecastCampaignPeriods
			.getCampaignPeriods()
			.subscribe(
				(response: any) => (this.campaignPeriods = response.body),
			);
	}

	selectEventCampaignMonth(item: any) {
		this.selectedCampaignMonth = item.id;
	}

	selectEventTypeMonth(item: any) {
		this.selectedTypeCampaignMonth = item.id;
	}

	selectEvent(item: any) {
		this.selectedCampaignMonth = item.id;
	}
	onChangeSearch(item: any) {
		this.selectedCampaignMonth = item.id;
	}
	onFocused(item: any) {
		this.selectedCampaignMonth = item.id;
	}

	get_month_filter(event: any) {
		let firstDate = event.target.selectMonth.value.substring(0, 10);
		let lastDate = event.target.selectMonth.value.substring(14, 24);
		let selectedCampaign = this.selectedCampaignMonth;
		let selectedTypeCampaign = this.selectedTypeCampaignMonth;

		if (firstDate != '' && lastDate != '') {
			this.isHidden = false;
			this.isSearch = true;
			this.ListJsListMonth$ = this.servicemonthsearch.SearchCampaign(
				firstDate,
				lastDate,
				selectedCampaign,
				selectedTypeCampaign,
			);
			this.total$ = this.servicemonthsearch.total$;
		} else {
			this.isHidden = true;
			this.isSearch = false;
		}
	}
}
